import React from 'react'
import StaffView from '../../components/staffdetailscomponents/StaffView'

const StaffDetailsView = () => {
  return <StaffView/>
}

export default StaffDetailsView